import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";
import Storage from "../../Data/Domain/Storage";

export async function getEmissionsByUser(years = []) {
  const userId = new Storage("id").getItem();
  let endpoint = URL.buildUrl(`users/${userId}/emissions`);
    if (years.length > 0) {
    const filter = JSON.stringify({ year: years });
    endpoint += `?filter=${encodeURIComponent(filter)}`;
  }  
  return await new API(endpoint).get();
}